import * as Yup from "yup";
import { AnyObject } from "yup/lib/types";

import { CallsAlertsSearchBarValues, EventType, Status } from "../../types";
import {
  dateValidation,
  isFirstDateAfterSecondDate,
} from "../../utils/yupValidation";

const LETTERS_N_NUMBERS_REGEX = /^$|^[0-9a-zA-Z/]+$/;
const NUMBERS_REGEX = /^[.,0-9]*$/;

const searchBarValidation: Yup.SchemaOf<CallsAlertsSearchBarValues> =
  Yup.object().shape({
    eventType: Yup.mixed<EventType>().default(EventType.Null),
    status: Yup.mixed<Status>()
      .oneOf(Object.values(Status))
      .default(Status.All),
    accountId: Yup.string()
      .max(11, "Must be 8-11 characters")
      .matches(LETTERS_N_NUMBERS_REGEX, "Invalid character")
      .default("")
      .test("minAccount", "Must be 8-11 characters", value => {
        if (value) {
          return value.length >= 8;
        }
        return true;
      }),
    fromTradeDate: dateValidation().default(""),
    toTradeDate: dateValidation()
      .test(
        "from must be before to date",
        "Invalid date pair",
        (value, context) =>
          isFirstDateAfterSecondDate(value, context.parent.fromTradeDate)
      )
      .default(""),
    toDueDate: dateValidation().default(""),
    fromDueDate: dateValidation().default(""),
    correspondentCode: Yup.array()
      .of(
        Yup.string()
          .max(10, "Maximum 10 characters")
          .matches(LETTERS_N_NUMBERS_REGEX, "Invalid character")
      )
      .default([]),
    callType: Yup.array().default([]),
    eventName: Yup.array().default([]),
    amountMinDisplay: Yup.string()
      .max(16, "Maximum 16 characters")
      .matches(NUMBERS_REGEX, "Invalid character")
      .default(""),
    amountMinRaw: Yup.number().optional().min(0.01, "Minimum amount: 0.01"),
    amountMaxDisplay: Yup.string()
      .max(16, "Maximum 16 characters")
      .matches(NUMBERS_REGEX, "Invalid character")
      .default(""),
    amountMaxRaw: Yup.number()
      .min(0.01, "Minimum amount: 0.01")
      .optional()
      .test(
        "min greater then max",
        "Min is > Max",
        isPassingMinNotGreaterThanMax
      ),
  });

export default searchBarValidation;

// VALIDATION TESTS
function isPassingMinNotGreaterThanMax(
  maxValue?: number,
  context?: Yup.TestContext<AnyObject>
) {
  const minVal = context?.parent.amountMinRaw;
  if (!minVal || !maxValue) return true;

  const isNumbers = typeof maxValue === "number" && typeof minVal === "number";
  return isNumbers && maxValue! >= minVal;
}
